export default __webpack_public_path__ + "static/media/Cart.67e22f0a.svg";